import { Box, List, ListItem, ListItemIcon, ListItemText, Stack, SvgIcon, Typography, useTheme } from "@mui/material"
import GuberImg from "../icons/guberJpg.jpg"
import Grid from "@mui/material/Unstable_Grid2";
import { ReactComponent as StarIcon } from '../icons/StarSmallIcon.svg'
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import GerbPng from '../icons/gerb.png'
import Divider from "../components/Divider/Divider";


const WrapIntro = ({ children }) => {
    return (
        <>
            <Box
                sx={{
                    position: 'relative',
                    height: '100%',
                    left: {
                        lg: '-20px',
                        xs: '-10x',
                    },
                    ml: 2,
                    mr: 2,
                }}>
                <Box sx={{
                    border: '4px solid',
                    borderColor: 'blue.500',
                    height: '100%',
                }}>
                    <Box sx={{
                        border: '4px solid',
                        borderColor: 'red.500',
                        position: 'relative',
                        top: {
                            lg: '32px',
                            xs: '16px',
                        },
                        left: {
                            lg: '32px',
                            xs: '16px',
                        },
                        width: 'calc(100% + 8px)',
                        height: 'calc(100% + 8px)',
                        pr: {
                            lg: 8,
                            xs: 4,
                        },
                        pl: {
                            lg: 8,
                            xs: 4,
                        },
                        pt: {
                            lg: 4,
                            xs: 2,
                        },
                        pb: {
                            lg: 5,
                            xs: 3,
                        },
                        textAlign: 'center',
                        alignItems: 'center',
                        display: 'flex'
                    }}>
                        {children}
                    </Box>
                </Box>
            </Box>
        </>
    )
}

const ItemBox = ({ label, children, id }) => (
    <Grid container id={id} spacing={4}>
        <Grid md={6} sm={12}>
            <Typography variant="h5" sx={sxBody4}>{label}</Typography>
        </Grid>

        <Grid md={6} sm={12} >
            {typeof children === 'string'
                ?
                <Typography variant="body1" sx={sxBody3}>{children}</Typography>
                : <Stack spacing={4}>{children}</Stack>
            }

        </Grid>
    </Grid>
)

const ItemList = ({ title, items = [] }) => {
    const theme = useTheme()
    return (
        <Stack>
            <Stack direction='row' spacing={2}>
                <Box sx={{ pt: { lg: '6px', sm: '4px', xs: '2px', } }}>
                    <SvgIcon >
                        <StarIcon />
                    </SvgIcon>
                </Box>
                <Typography variant="body1" sx={sxBody3}>{title}</Typography>
            </Stack>

            <Box sx={{ ml: 3 }}>
                <List disablePadding>
                    {items.map(item => (
                        <ListItem disablePadding sx={{ alignItems: 'flex-start', justifyContent: 'flex-start' }} key={item}>
                            <ListItemIcon sx={{ minWidth: '30px', mt: { lg: '8px', sm: '8px', xs: '4px', } }}>
                                <HorizontalRuleIcon fontSize="small" sx={{ fill: theme.palette.blue[400] }} />
                            </ListItemIcon>
                            <ListItemText>
                                <Typography variant="body2" sx={{
                                    color: 'black.400',
                                    opacity: 0.6,
                                }}>{item}</Typography>
                            </ListItemText>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Stack>
    )
}

const HomePage = () => {

    return (
        <>
            <Stack spacing={adaptiveSx}>

                <Grid container columnSpacing={5}>
                    <Grid md={6} sm={12} sx={{
                        display: 'flex', justifyContent: 'center',
                        pb: {
                            xs: 2.5,
                            md: 0,
                            lg: 0,
                        }
                    }}>
                        <Box sx={{
                            width: { md: '100%', sm: '70%', },
                            pl: { md: 0, xs: 2, },
                            pr: { md: 0, xs: 2, },
                        }}>
                            {/* <img src={GuberPng} alt='' style={{ width: '100%', }} /> */}
                            <img src={GuberImg} alt='' style={{ width: '100%', }} />
                        </Box>
                    </Grid>

                    <Grid md={6} sm={12} sx={{ display: 'inline-block' }}>
                        <WrapIntro>
                            <Typography variant="body1" sx={sxBody_2}>
                                «Наш Президент назвал участников и ветеранов СВО новой элитой страны и подчеркнул, что они своими поступками подтвердили преданность России. Владимир Владимирович поручил запустить аналог федеральной программы «Время героев» во всех регионах. Поддержка бойцов и членов их семей — одна из важнейших задач. Запуская региональную программу в Ярославской области, мы создаем эффективный кадровый лифт. В дальнейшем успешно прошедшие подготовку участники СВО будут полезны региону в органах власти и государственных компаниях. Их будут обучать современным методам и технологиям управления»
                                {/* «Поддержка воинов и членов их семей для меня — одна из важнейших задач. Запуская региональную программу в Ярославской области, мы создаем эффективный кадровый лифт. В дальнейшем успешно прошедшие подготовку участники СВО принесут пользу региону в органах власти и государственных компаниях. Их будут обучать современным методам и технологиям управления» */}
                            </Typography>
                        </WrapIntro>
                    </Grid>
                </Grid>

                <Divider />

                <ItemBox label='ЦЕЛИ ПРОГРАММЫ'>
                    <ItemList title='Подготовка высококвалифицированных, компетентных руководителей и специалистов из числа действующих и бывших военнослужащих для последующей работы в органах государственной и муниципальной власти, а также государственных компаниях, общественном секторе, бизнес-структурах Ярославской области.' />
                    <ItemList title='Укрепление кадрового потенциала Ярославской области.' />
                    <ItemList title={
                        <>Содействие ветеранам боевых действий, участникам СВО в реализации собственного потенциала.<br />Программа предполагает обучение современным методам и технологиям управления, командной работе, личностное развитие.</>} />
                </ItemBox>

                <Divider />

                <ItemBox label='ЧТО ПОЛУЧАЮТ УЧАСТНИКИ ОТБОРА НА ПРОГРАММУ'>
                    <Typography sx={sxBody2}>Что получают участники, показавшие наиболее высокие результаты:</Typography>
                    <ItemList title='Зачисление на дополнительную профессиональную программу профессиональной переподготовки «Герои Ярославии»' />
                    <ItemList title='Стажировки в органах государственной власти, на предприятиях, в общественных организациях и бизнес-структурах  региона' />
                    <ItemList title='Наставничество ведущими управленцами региона' />
                </ItemBox>

                <Divider />

                <ItemBox label='УСЛОВИЯ УЧАСТИЯ В ОТБОРЕ НА ПРОГРАММУ'>
                    <Typography sx={sxBody2}>К участию в отборе допускаются граждане Российской Федерации:</Typography>

                    <ItemList title='Действующие или завершившие службу участники Специальной военной операции' />
                    <ItemList title='Проживающие в Ярославской области' />
                    <ItemList title='Имеющие высшее или среднее профессиональное образование' />
                    <ItemList title='Имеющие опыт управления людьми' />
                </ItemBox>
                <Divider />

                <ItemBox id='steps' label='ЭТАПЫ ОТБОРА'>
                    <Typography sx={sxBody2}>РЕГИСТРАЦИЯ:</Typography>
                    <ItemList title={<>Участники проходят регистрацию, заполняют анкету, размещают эссе о целях участия в программе в личном кабинете <br />(24.02.2025 – 24.03.2025)</>} />

                    <Typography sx={sxBody2}>ТЕСТИРОВАНИЕ:</Typography>
                    <ItemList title={<>Участники проходят тестирование в личном кабинете<br />(31.03.2025 - 28.04.2025)</>} />

                    <Typography sx={sxBody2}>СОБЕСЕДОВАНИЕ:</Typography>
                    <ItemList title={<>Участники приглашаются на собеседование с членами Общественного совета программы <br />(05.05.2025 - 02.06.2025)</>} />

                    <Typography sx={sxBody2}>ПОДВЕДЕНИЕ ИТОГОВ:</Typography>
                    <ItemList title={<>Общественный совет определяет финалистов программы <br />(30.06.2025)</>} />
                </ItemBox>

                <Divider />

                <ItemBox id='steps' label='ОРГАНИЗАТОР'>
                    <Stack direction='row' alignItems='center' spacing={3} sx={{
                        position: 'relative',
                        top: '-16px'
                    }}>
                        <Box sx={{ width: '55px' }}>
                            <img src={GerbPng} alt='Правительство Ярославской области' style={{ width: '100%' }} />
                        </Box>
                        <Typography variant="body1" sx={sxBody3}>Правительство Ярославской области</Typography>
                    </Stack>
                </ItemBox>

            </Stack>
        </>
    )
}

export default HomePage


const sxBody2 = {
    fontSize: {
        sm: '30px',
        md: '26px',
        xs: '22px',
    }
}

const sxBody3 = {
    color: 'blue.400',
    fontSize: {
        lg: '26px',
        sm: '22px',
        xs: '20px',
    }
}

const sxBody4 = {
    fontWeight: 700,
    fontSize: {
        lg: '48px',
        sm: '44px',
        xs: '30px',
    },
    letterSpacing: '2px',
    lineHeight: '57.6px',
}

const sxBody_2 = {
    fontSize: {
        sm: '30px',
        md: '26px',
        xs: '22px',

        md: '20px',
        sm: '22px',
        xs: '20px',
    }
}

const adaptiveSx = {
    lg: 15,
    md: 12,
    sm: 8,
    xs: 4
}